// extracted by mini-css-extract-plugin
module.exports = {"container":"StackEdit__container___2ZbaJ Stack__content___WKaEz","isGitless":"StackEdit__isGitless___Wzb9R"};